import {
    PROFILE_DETAILS_SUCCESS,
    PROFILE_DETAILS_FAILURE,
    EDIT_NAME,
    EDIT_TITLE,
    UPDATE_PASSWORD,
    OUT_OF_OFFICE,
    UPLOAD_PROFILE_PIC,
    DISPLAY_NOTIFICATION,
    UPDATE_NOTIFICATION,
} from '../actions/ProfileActions'

const initialState = {
    loading:true,
    accountDetails:{},
    userPermissions:[],
    role_name:"",
    error:''
}
import { encryptStorage } from 'src/Util';

const ProfileReducer = function(state = initialState, action) {
    const role_name=encryptStorage.getItem('session-role');
    //console.log("role_name", role_name)
   /* if(role_name!=undefined){
        const userPermissionList =[];
        let roleValidate=false;
        if(role_name=="Check User"){
            userPermissionList.push("accessibility_check");
            roleValidate=true;
        }else if(role_name=="Fix User"){
            userPermissionList.push("accessibility_check")
            userPermissionList.push("accessibility_fix")
            roleValidate=true;
        }else if(role_name=="Master User" || role_name=="Super Admin" || role_name=="Admin"){
            userPermissionList.push("accessibility_check")
            userPermissionList.push("accessibility_fix")
            userPermissionList.push("accessibility_review")
            roleValidate=true;
        }else{console.log("Role not matched...")}
        if(roleValidate){
            return {
                ...state,
                loading:false,
                accountDetails:action.payload,
                role_name:role_name,
                userPermissions:userPermissionList,
            }
        }


    }*/
    switch (action.type) {
        case PROFILE_DETAILS_SUCCESS: {
            const userPermissionList =[];
            
            action.payload.rights.forEach((data)=>{
                if(data.rights_type){
                    userPermissionList.push(data.rights_name)
                }

            })
           
            //userPermissionList.push("test01")
            //console.log('userAccount frmReducer : ',userPermissionList, action.payload, role_name)
            return {
                ...state,
                loading:false,
                accountDetails:action.payload,
                role_name:role_name,
                userPermissions:userPermissionList,
            }
          
        }

        case PROFILE_DETAILS_FAILURE: {
            
            return {
                ...state,
                loading:false,
                accountDetails:{},
                error:action.payload
            }
        }

        case EDIT_NAME: {
            return {
                ...state,
                editNameResponse: action.payload
            }
        }

        case EDIT_TITLE: {
            return {
                ...state,
                editTitleResponse: action.payload
            }
        }

        case UPDATE_PASSWORD: {
            return {
                ...state,
                updatePasswordResponse:action.payload
            }
        }

        case OUT_OF_OFFICE: {
            return {
                ...state,
                outOfOfficeResponse:action.payload
            }
        }

        case UPLOAD_PROFILE_PIC: {
            return {
                ...state,
                uploadProfilePicResponse:action.payload
            }
        }

        case DISPLAY_NOTIFICATION: {
            return {
                ...state,
                companyNotification:action.payload
            }
        }

        case UPDATE_NOTIFICATION: {
            return{
                ...state,
                updateNotification:action.payload
            }
        }

        default:
            return state
    }
}

export default ProfileReducer;